import { create } from 'zustand';
import type { JacintaMemoryEntry } from '@/modules/shared/types/yc-demo';
import { seedMemories } from '@/modules/brain/data/seedMemories';

const STORAGE_KEY = 'ats-spa.brain.memories.v1';

function loadFromStorage(): JacintaMemoryEntry[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as JacintaMemoryEntry[];
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch {
    // Fall through to seed.
  }
  return seedMemories;
}

function saveToStorage(entries: JacintaMemoryEntry[]) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch {
    // Ignore quota / privacy errors — store still works in-memory for the session.
  }
}

interface MemoryStore {
  memories: JacintaMemoryEntry[];
  addMemory: (entry: JacintaMemoryEntry) => void;
  resetToSeed: () => void;
}

export const useJacintaMemory = create<MemoryStore>((set, get) => ({
  memories: loadFromStorage(),
  addMemory(entry) {
    const next = [entry, ...get().memories];
    saveToStorage(next);
    set({ memories: next });
  },
  resetToSeed() {
    saveToStorage(seedMemories);
    set({ memories: seedMemories });
  },
}));
